import '../globals';
import {Popover} from "bootstrap";

;(function ($, window) {
    'use strict';

    var pluginName = 'erpShoppingBasket';

    function Plugin(element) {
        this._name = pluginName;
        this.element = $(element);
        this.queryUrl = $(element).data('query-erp-url');
        this.loadingIndicator = $(this.element).prevAll('.erp-loading-indicator');
        this.listReplace = $(this.element).find('.erp-list-replace');
        this.summaryReplace = $(this.element).find('.erp-summary-replace');
        this.loadingProgressTimeout = null;

        this.init();
        return this;
    }

    $.extend(Plugin.prototype, {
        init: function () {
            this.showLoadingIndicator();

            var that = this;

            // We need to wait for prices to be loaded
            // because the AX query depends on the per customer stored price data
            //
            // Usually prices are queried and stored in the first checkout step
            // However, if the user is forced to login in the second step,
            // we lose the stored prices from before.
            $(window).on('buy-data-loaded-all', function () {
                that.loadBasket();
            });
        },

        loadBasket: function () {
            let that = this;

            console.info('Querying AX prices');
            $.get(this.queryUrl, function (data) {
                let dataList = $(data).find('#erp-list');
                if (dataList.length > 0) {
                    that.listReplace.html($(data).find('#erp-list'));
                    that.summaryReplace.html($(data).find('#erp-summary'));

                    const listReplacePopovers = that.listReplace.find('[data-bs-toggle="popover"]');
                    if (listReplacePopovers.length) {
                        Array.from(listReplacePopovers).forEach((popoverEl) => {
                            const popover = Popover.getOrCreateInstance(popoverEl);
                        });
                    }
                    const summaryReplacePopovers = that.summaryReplace.find('[data-bs-toggle="popover"]');
                    if (summaryReplacePopovers.length) {
                        Array.from(summaryReplacePopovers).forEach((popoverEl) => {
                            const popover = Popover.getOrCreateInstance(popoverEl, {
                                container: 'body'
                            });
                        });
                    }
                } else {
                    that.showErrorMessage();
                }
            }).always(function () {
                that.hideLoadingIndicator();
            }).fail(function () {
                that.showErrorMessage();
            });
        },

        showErrorMessage: function () {
            this.listReplace.prevAll('.erp-error-message').removeClass('d-none');
        },

        showLoadingIndicator: function () {
            this.element.css('opacity', 0.15);
            this.loadingIndicator.removeClass('d-none');

            this.loadingIndicator.find('span').removeClass('d-none');
            this.loadingIndicator.find('.erp-loading-indicator__in-progress').addClass('d-none');

            var that = this;
            function updateLoadingIndicator() {
                that.loadingIndicator.find('span').addClass('d-none');
                that.loadingIndicator.find('.erp-loading-indicator__in-progress').removeClass('d-none');
            }

            this.loadingProgressTimeout = setTimeout(updateLoadingIndicator, 5000)
        },

        hideLoadingIndicator: function () {
            clearTimeout(this.loadingProgressTimeout);

            this.element.fadeTo('fast', 1.0);
            this.loadingIndicator.addClass('d-none');
        }
    });

    /**
     * Plugin Wrapper
     *
     * @param options
     * @returns {*}
     */
    $.fn[pluginName] = function ( options ) {
        var args = arguments;

        if (options === undefined || typeof options === 'object') {
            return this.each(function () {
                if (!$.data(this, 'plugin_' + pluginName)) {
                    $.data(this, 'plugin_' + pluginName, new Plugin( this, options ));
                }
            });
        } else if (typeof options === 'string' && options[0] !== '_' && options !== 'init') {
            var returns;

            this.each(function () {
                var instance = $.data(this, 'plugin_' + pluginName);
                if (instance instanceof Plugin && typeof instance[options] === 'function') {
                    returns = instance[options].apply( instance, Array.prototype.slice.call( args, 1 ) );
                }

                if (options === 'destroy') {
                    $.data(this, 'plugin_' + pluginName, null);
                }
            });

            return returns !== undefined ? returns : this;
        }
    };
})(jQuery, window);
